/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import { Tabs, Empty } from 'antd'

type Props = {
    uiConfig?: {
        networkTabEnabled: boolean;
        iotTabEnabled: boolean;
        networkDevices: string[];
        iotDevices: string[];
    }
};
const network_icons = [
    { 
        name: '计算机',
        img: require('../../assets/icon/pc.png'),
    },

    { 
        name: '交换机',
        img: require('../../assets/icon/switch.png'),
    },

    { 
        name: '无线路由器',
        img: require('../../assets/icon/home_gateway.png'),
    },

    { 
        name: 'DHCP服务器',
        img: require('../../assets/icon/dhcp_server.png'),
    },

    { 
        name: '移动终端',
        img: require('../../assets/icon/phone.png'),
    },

    { 
        name: '无线接入点',
        img: require('../../assets/icon/ap.png'),
    },

    { 
        name: '调制解调器',
        img: require('../../assets/icon/modem.png'),
    },

    { 
        name: '路由器',
        img: require('../../assets/icon/router.png'),
    },

    { 
        name: '防火墙',
        img: require('../../assets/icon/firewall.png'),
    },
]

const iot_icons = [
    { 
        name: '智能音箱',
        img: require('../../assets/icon/smartaudio.png'),
    },
    { 
        name: '智能门铃',
        img: require('../../assets/icon/doorbell.png'),
    },
    { 
        name: '智能门锁',
        img: require('../../assets/icon/lock.png'),
    },
    { 
        name: '智能灯泡',
        img: require('../../assets/icon/bulb.png'),
    },
    { 
        name: '投影机',
        img: require('../../assets/icon/projector.png'),
    },
    { 
        name: '空调',
        img: require('../../assets/icon/airconditioner.png'),
    },
    { 
        name: '投影幕布',
        img: require('../../assets/icon/screen_on.png'),
    },
]


const SetncilBar: React.FunctionComponent<Props> = props => {
    const { uiConfig } = props;
    const setCurrentDragDevice = (e: any, icon: any) => {
        const deviceName = (icon && icon.name)
            || (e.currentTarget && e.currentTarget.dataset && e.currentTarget.dataset.device)
            || (e.target && e.target.dataset && e.target.dataset.device);
        if (!deviceName) {
            return;
        }
        (window as any).__hxrCurrentDragDevice = deviceName;
        return deviceName;
    }

    const onDragStart = (e: any, icon: any) => {
        const deviceName = setCurrentDragDevice(e, icon);
        if (!deviceName) {
            return;
        }
        if (e.dataTransfer && e.dataTransfer.clearData) {
            e.dataTransfer.clearData();
        }
        // 双重写入，兼容不同 dataTransfer 实现
        e.dataTransfer.setData('application/x-device', deviceName);
        e.dataTransfer.setData('text/plain', deviceName);
        e.dataTransfer.setData('text', deviceName);
    };

    const onMouseDown = (e: any, icon: any) => {
        setCurrentDragDevice(e, icon);
    };

    const mergedConfig = uiConfig || {
        networkTabEnabled: true,
        iotTabEnabled: true,
        networkDevices: network_icons.map(i => i.name),
        iotDevices: iot_icons.map(i => i.name),
    };

    // 根据开关动态决定标题
    const title = (() => {
        const { networkTabEnabled, iotTabEnabled } = mergedConfig;
        if (networkTabEnabled && iotTabEnabled) {
            return '物联网络模拟器';
        }
        if (networkTabEnabled) {
            return '网络模拟器';
        }
        if (iotTabEnabled) {
            return '物联网模拟器';
        }
        return '物联网络模拟器';
    })();

    const enabledNetworkIcons = mergedConfig.networkDevices.length
        ? network_icons.filter(icon => mergedConfig.networkDevices.includes(icon.name))
        : [];
    const enabledIotIcons = mergedConfig.iotDevices.length
        ? iot_icons.filter(icon => mergedConfig.iotDevices.includes(icon.name))
        : [];

    const tabs: Array<{ key: string; label: string; enabled: boolean; icons: typeof network_icons }> = [
        { key: 'network', label: '网络', enabled: mergedConfig.networkTabEnabled, icons: enabledNetworkIcons },
        { key: 'iot', label: '物联网', enabled: mergedConfig.iotTabEnabled, icons: enabledIotIcons },
    ].filter(tab => tab.enabled);

    const renderList = (icons: typeof network_icons) => {
        if (!icons.length) {
            return <Empty description="无可用设备" />;
        }
        return (
            <ul style={{ flex: 1, listStyle: 'none', padding: 0, margin: 0, textAlign: 'center', height: 'calc(100vh - 120px)', overflow: 'auto' }}>
                {icons.map(icon => (
                    <li
                        key={icon.name}
                        draggable="true"
                        data-device={icon.name}
                        onMouseDown={(e) => { onMouseDown(e, icon); }}
                        onDragStart={(e) => { onDragStart(e, icon); }}
                        style={{ marginTop: 20 }}
                    >
                        <img alt={icon.name} draggable="false" style={{height: 50}} src={icon.img} />
                        <h5 style={{marginTop: 5}}>{icon.name}</h5>
                    </li>
                ))}
            </ul>
        );
    };

    if (!tabs.length) {
        return (
            <div
                style={{
                    position: 'relative',
                    width: '130px',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    userSelect: 'none',
                    overflow: 'auto',
                }}
            >
                <div style={{ width: '100%', color: '#333333', background: '#ededed', padding: 8, textAlign: 'center' }}>{title}</div>
                <Empty description="已被管理员禁用" style={{ marginTop: 40 }} />
            </div>
        );
    }

    // 仅剩一个Tab时直接展示内容，不显示Tabs标签
    if (tabs.length === 1) {
        const tab = tabs[0];
        return (
            <div
                style={{
                    position: 'relative',
                    width: '130px',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    userSelect: 'none',
                    overflow: 'auto',
                }}
            >
                <div style={{ width: '100%', color: '#333333', background: '#ededed', padding: 8, textAlign: 'center' }}>{title}</div>
                <div style={{ padding: '10px 0 10px 10px' }}>
                    {renderList(tab.icons)}
                </div>
            </div>
        );
    }

    const defaultActiveKey = tabs[0].key;

    return (
        <div
            style={{
                position: 'relative',
                width: '130px',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                userSelect: 'none',
                overflow: 'auto',
            }}
        >
            <div style={{ width: '100%', color: '#333333', background: '#ededed', padding: 8, textAlign: 'center' }}>{title}</div>
            {/* 用Tabs切换网络设备与物联网设备 */}
            <Tabs style={{ padding: '10px 0 10px 10px' }} defaultActiveKey={defaultActiveKey}>
                {tabs.map(tab => (
                    <Tabs.TabPane tab={tab.label} key={tab.key}>
                        {renderList(tab.icons)}
                    </Tabs.TabPane>
                ))}
            </Tabs>
        </div>
    )
}

export default SetncilBar;